import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { Paymentmethod } from '../../_model/order';
import { Countrycode } from '../../_model/shared';
import { PricingService } from '../../_service/PricingService';
import { Colorscheme } from '../../_theme/colorscheme';

@Directive()
export abstract class PaymentmethodBaseComponent implements OnInit, OnDestroy {

  private _colorscheme = Colorscheme.light;
  @Input() set colorscheme(value: Colorscheme | string) {
    if (value)
      this._colorscheme = this.getKeyByKeyOrValue(value);
  }
  get colorscheme(): Colorscheme {
    return this._colorscheme
  }

  @Input() set contrastColorscheme(value: Colorscheme | string) {
    const scheme = this.getKeyByKeyOrValue(value)
    switch (scheme) {
      case Colorscheme.light:
        this._colorscheme = Colorscheme.white;
        break;
      case Colorscheme.white:
        this._colorscheme = Colorscheme.light;
        break;
      default: this._colorscheme = Colorscheme.light;
    }
  }

  private getKeyByKeyOrValue(value: string): Colorscheme {
    const indexOfValue = Object.values(Colorscheme).indexOf(value as unknown as Colorscheme);
    if (indexOfValue >= 0)
      return Colorscheme[Object.keys(Colorscheme)[indexOfValue]];

    const indexOfKey = Object.keys(Colorscheme).indexOf(value as unknown as Colorscheme);
    if (indexOfKey >=0)
      return Colorscheme[Object.keys(Colorscheme)[indexOfKey]];

    console.warn(value + ' is not a recognised colorscheme')
  }

  idealIssuers: string[];
  creditcardnetworks: string[];

  paymentForm: FormGroup = new FormGroup({
    paymentmethod: new FormControl(null),
    creditcardnetwork: new FormControl(null)
  });

  paymentmethodOrder: Paymentmethod[] = [Paymentmethod.IDEAL, Paymentmethod.BANCONTACT, Paymentmethod.CREDITCARD, Paymentmethod.EMAIL, Paymentmethod.NONE];

  _countrycode: Countrycode
  @Input() set countrycode(value: Countrycode) {
    if (value) {
      this._countrycode = value;
      if (this.paymentForm)
        this.setPaymentmethod();
      this.sortPaymentMethods();
    }
  }
  _paymentmethod: Paymentmethod
  @Input() set paymentmethod(value: Paymentmethod) {
    if (this.paymentForm)
      this.paymentForm.get('paymentmethod').setValue(value);
    this._paymentmethod = value;
  }
  
  @Input() set creditcardnetwork(value: string) {
    if (value && this.paymentForm)
      this.paymentForm.get('creditcardnetwork').setValue(value);
  }

  _availablePaymentmethods: Paymentmethod[] = [Paymentmethod.BANCONTACT, Paymentmethod.IDEAL, Paymentmethod.CREDITCARD, Paymentmethod.NONE];
  @Input() set availablepaymentmethods(value: Paymentmethod[] | string[]) {
    this._availablePaymentmethods = value.map(p => Paymentmethod[p])
  }

  @Output() paymentmethodChange = new EventEmitter<Paymentmethod>();

  @Output() creditcardnetworkChange = new EventEmitter<string>();

  protected unsubscribe = new Subject<void>();

  constructor(
    protected _pricingService: PricingService,
    public fb: FormBuilder
  ) {
  }

  ngOnInit(): void {

    this.creditcardnetworks = this._pricingService.getCreditcardNetworks();

    this.paymentForm.get('paymentmethod').setValue(this._paymentmethod);    

    this.paymentForm.get('paymentmethod').valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      if (result && result !== Paymentmethod.CREDITCARD) this.paymentForm.get('creditcardnetwork').reset();

      this.paymentmethodChange.emit(result);
     
    })
    this.paymentForm.get('creditcardnetwork').valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe(result => {
      this.creditcardnetworkChange.emit(result);
    })

    this.setPaymentmethod();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  includesPaymentmethod(value: string): boolean {
    return this._availablePaymentmethods.includes(Paymentmethod[value]);
  }

  setPaymentmethod() {
    if (this.paymentForm.get('paymentmethod').value) return;

    if (this._countrycode === Countrycode.NL && this._availablePaymentmethods.includes(Paymentmethod.IDEAL)) {
      this.paymentForm.get('paymentmethod').setValue(Paymentmethod.IDEAL);
    } else if (this._countrycode === Countrycode.BE && this._availablePaymentmethods.includes(Paymentmethod.BANCONTACT)) {
      this.paymentForm.get('paymentmethod').setValue(Paymentmethod.BANCONTACT);
    }

    if (this._availablePaymentmethods.length === 1) {
      this.paymentForm.get('paymentmethod').setValue(this._availablePaymentmethods[0]);
    }

  }
  sortPaymentMethods() {
    this.paymentmethodOrder = [Paymentmethod.IDEAL, Paymentmethod.BANCONTACT, Paymentmethod.EMAIL, Paymentmethod.CREDITCARD];

    if (this._countrycode === Countrycode.BE) {
      this.paymentmethodOrder = [Paymentmethod.BANCONTACT,  Paymentmethod.CREDITCARD, Paymentmethod.IDEAL, Paymentmethod.EMAIL];
    }

    let methods = this._pricingService.getPaymentmethods();

    methods.forEach(m => {
      if (!this.paymentmethodOrder.includes(Paymentmethod[m]))
        this.paymentmethodOrder.push(Paymentmethod[m])
    })
  }
  hasError = (controlName: string, errorName: string) => {
    return this.paymentForm.get(controlName).hasError(errorName);
  }

}

